import { useQuery, UseQueryOptions } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'
import {
  ProviderSubscriptionPlan,
  SecondaryRole,
  teamLevel,
  TeamStaffRole,
} from './types'
import { User } from './useCurrentUser'
import { Study } from './useStudies'

export interface Provider {
  id: string
  userId: string
  organizationId: string
  firstName: string
  lastName: string
  type: 'Provider'
  subscriptionPlan: ProviderSubscriptionPlan
  npi: string
  title: string
  residentFellow: string | null
  secondaryRole: SecondaryRole
  societiesAffiliations: string[]
  specialty: string[]
  positions: string[]
  user?: User
  isAdmin: boolean
  activated: boolean
  teams?: Team[]
  additionalData?: {
    onboardingReview?: OnboardingReview
  }
}

export interface OnboardingReview {
  outcomeGoals: string[]
  patientAchievements: string[]
  clinicTreatments: string[]
  proceduresPerMonth: string
  clinicSystem: string
  ehrIntegration: boolean
}

export interface Team {
  id: string
  name: string
  shortName: string
  slug: string
  description: string
  status: string
  level: teamLevel
  hubspotId: string
  sponsorId: string
  badgeUrl: string
  createdAt: string
  updatedAt: string
  teamStaffs?: TeamStaff[]
  sponsor?: Sponsor
}
export interface Sponsor {
  id: string
  name: string
  slug: string
  subscriptionPlan: string
  sponsorType: string
  hubspotId: string
  logoUrl: string
  providersAvailable?: number
  providersUsed?: number
  createdAt: string
  updatedAt: string
  staffs?: Provider[]
  studies?: Study[]
}
export interface TeamStaff {
  id: string
  teamId: string
  staffId: string
  role: TeamStaffRole
  status: string
  team?: Team
  staff?: Provider
  createdAt: string
  updatedAt: string
}
interface ProviderResponse {
  providers: Provider[]
}

const useProviders = (extraOptions: UseQueryOptions<Provider[]> = {}) => {
  const siteId = useCurrentSite()?.id
  const key = QueryKeys.providers(siteId)
  const url = `/impacts/providers?site_ids[]=${siteId}`

  return useQuery(
    key,
    () => request.get<ProviderResponse>(url).then((r) => r.data.providers),
    extraOptions,
  )
}

export default useProviders
